// Validace formuláře
function isElementVisible(element)
{
    var style = window.getComputedStyle(element);

    if (style.display === 'none' || style.visibility === 'hidden')
        return false;

    if (element.parentNode && element.parentNode.nodeType === Node.ELEMENT_NODE)
        return isElementVisible(element.parentNode);

    return true;
}

window.validator =
{
    bindInteractiveForm: function (form, options)
    {
        var inputs = form.querySelectorAll("input, select, textarea");
        var submitButton = form.querySelector(":scope button[type='submit']");

        inputs.forEach(input =>
        {
            input.addEventListener("input", function (e)
            {
                validator.validateField(input);
                validator.validateForm(form, options);
            });
        });

        submitButton.addEventListener("click", async function (e)
        {
            e.preventDefault();

            if (submitButton.getAttribute("data-disabled") === "true")
                return;

            submitButton.setAttribute("data-disabled", "true");

            var isValid = true;
            var firstInvalidInput = null;

            for (var input of inputs)
            {
                var isFieldValid = validator.validateField(input);

                if (isFieldValid)
                    continue;

                if (firstInvalidInput == null)
                    firstInvalidInput = input;

                isValid = false;
            }

            if (!validator.validateForm(form, options))
                isValid = false;

            if (!isValid)
            {
                e.stopPropagation();

                submitButton.removeAttribute("data-disabled");

                if (firstInvalidInput)
                {
                    firstInvalidInput.scrollIntoView({ behavior: "smooth", block: "center" });

                    setTimeout(() => firstInvalidInput.focus(), 500);
                }

                return;
            }

            if (form.dataset.api === "true")
                await submitApiForm(form);
            else if (form.dataset.ajax === "true")
                await submitAjaxForm(form);
            else
                form.submit();

            submitButton.removeAttribute("data-disabled");
        });

        validator.validateForm(form, options);
    },
    compareInput(input, target)
    {
        return input.value === target.value;
    },
    getInputErrorMessage: function (input)
    {
        if (input.validity.valueMissing)
            return input.dataset.required;

        if (input.validity.patternMismatch)
        {
            if (input.dataset.email)
                return input.dataset.email;

            if (input.dataset.phone)
                return input.dataset.phone;

            if (input.dataset.regex)
                return input.dataset.regex;
        }

        if (input.validity.typeMismatch)
        {
            if (input.dataset.email)
                return input.dataset.email;

            if (input.dataset.url)
                return input.dataset.url;
        }

        if (input.validity.tooShort)
            return input.dataset.minlength;

        if (input.validity.tooLong)
            return input.dataset.maxlength;

        if (input.validity.rangeUnderflow || input.validity.rangeOverflow)
            return input.dataset.range;

        if (input.dataset.regexExpr && input.value.length !== 0)
            return input.dataset.regex;

        if (input.dataset.compare)
            return input.dataset.compare;

        if (input.dataset.requiredWhen && input.dataset.requiredWhenValid !== "true")
            return input.dataset.requiredWhen;

        return null;
    },
    resetForm: function (form)
    {
        if (form.getAttribute("data-interactive") !== "true")
            return;

        var inputs = form.querySelectorAll("input, select, textarea");

        inputs.forEach(input =>
        {
            input.classList.remove("is-invalid");
            input.classList.remove("is-valid");

            var help = input.parentNode.querySelector(":scope .field-validation-valid");

            if (help)
                help.classList.add("d-none");
        });
    },
    validateForm: function (form, options, force)
    {
        var disableButton = false;

        if (options !== null)
        {
            if (options.disableButton === true)
                disableButton = true;
        }

        var isValid = form.checkValidity();

        if (disableButton && !isValid)
            form.querySelector(":scope button[type='submit']").disabled = true;
        else if (disableButton && isValid)
            form.querySelector(":scope button[type='submit']").disabled = false;

        return isValid;
    },
    validateField: function (input)
    {
        if (input.type === "hidden" || !isElementVisible(input) || input.type === "checkbox" && !input.required)
            return true;

        var help = input.parentNode.querySelector(":scope .field-validation-valid");

        var isDisabledUI = input.dataset.disableUi === "true";
        var isValid = input.validity.valid;

        if (input.dataset.compareTarget)
        {
            var target = input.form.querySelector(":scope *[name='" + input.dataset.compareTarget + "']");

            isValid = isValid && validator.compareInput(input, target);
        }

        if (input.dataset.regexExpr)
            isValid = isValid && validator.validateRegexExpression(input, input.dataset.regexExpr);

        if (input.dataset.requiredWhenTarget)
        {
            isValid = isValid && validator.validateRequiredWhen(input, input.dataset.requiredWhenTarget);

            input.dataset.requiredWhenValid = isValid ? "true" : "false";
        }

        if (isDisabledUI)
            return isValid;

        if (isValid)
        {
            input.classList.remove("is-invalid");
            input.classList.add("is-valid");

            if (help && help.dataset.validMessage)
            {
                help.classList.remove("invalid-tooltip");
                help.classList.add("valid-tooltip");
                help.classList.remove("d-none");
            }
            else if (help)
            {
                help.classList.remove("valid-tooltip");
                help.classList.remove("invalid-tooltip");
                help.classList.add("d-none");
            }
        }
        else
        {
            input.classList.remove("is-valid");
            input.classList.add("is-invalid");

            var errorMessage = validator.getInputErrorMessage(input);

            if (help)
                help.classList.remove("valid-tooltip");

            if (help && errorMessage)
            {
                help.classList.remove("d-none");
                help.classList.add("invalid-tooltip");

                help.innerHTML = errorMessage;
            }
        }

        return isValid;
    },
    validateRegexExpression: function (input, pattern)
    {
        if (input.value.length === 0)
            return true;

        var regex = new RegExp(pattern);

        return regex.test(input.value);
    },
    validateRequiredWhen: function (input, target)
    {
        var targetElement = document.querySelector("*[name='" + target + "']");

        if (targetElement === null)
            return true;

        // pokud je checkbox tak je vyžadován vždy pokud je objekt viditelný
        if (targetElement.type === "checkbox" && input.value.trim() !== "")
            return true;

        // pokud je target vyplněný a input také tak je valid
        if (targetElement.value.trim() !== "" && input.value.trim() !== "")
            return true;

        // pokud je target prázdný tak není vyžadováno vyplnění inputu
        if (targetElement.value.trim() === "")
            return true;

        return false;
    }
};